import { render, staticRenderFns } from "./FilterItemTags.vue?vue&type=template&id=0d65f9e9&"
import script from "./FilterItemTags.vue?vue&type=script&lang=js&"
export * from "./FilterItemTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports